export default "//cdn.scentbird.com/assets/frontbird-site/images/beer_0a812c.jpg";